import { render, staticRenderFns } from "./PreApprovalLetter.vue?vue&type=template&id=7faccfca&scoped=true&"
import script from "./PreApprovalLetter.vue?vue&type=script&lang=js&"
export * from "./PreApprovalLetter.vue?vue&type=script&lang=js&"
import style0 from "./PreApprovalLetter.vue?vue&type=style&index=0&id=7faccfca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faccfca",
  null
  
)

export default component.exports